// Angular wrapper for http://eonasdan.github.io/bootstrap-datetimepicker/



import {default as app} from '@legacy/App';
import * as _angular_ from 'angular';



    app

    .constant('datetimePickerDefaults', {
        focusOnShow: false,
        showClear: true,
        showClose: true,
        showTodayButton: true,
        toolbarPlacement: 'bottom',
        useCurrent: false
    })

    .directive('datetimePicker', ['$window', '$document', '$timeout', 'datetimePickerDefaults', function ($window, $document, $timeout, datetimePickerDefaults) {
        return {
            require: ['ngModel'],
            restrict: 'A',
            scope: {
                onChange: '&?',
                onError: '&?',
                onHide: '&?',
                onShow: '&?',
                onUpdate: '&?'
            },
            link: function (scope, elem, attrs, controllers) {
                var ngModelCtrl = controllers[0];

                // configuration
                var config = angular.extend({}, (<any>$.fn).datetimepicker.defaults, datetimePickerDefaults, { format: attrs.datetimePicker, locale: moment.locale() });

                angular.forEach(['allowInputToggle', 'calendarWeeks', 'collapse', 'daysOfWeekDisabled', 'debug', 'defaultDate', 'disabledDates',
                    'disabledHours', 'disabledHours', 'disabledTimeIntervals', 'enabledDates', 'enabledHours', 'extraFormats', 'focusOnShow', 'format', 'icons',
                    'ignoreReadonly', 'inline', 'keepInvalid', 'keepOpen', 'keyBinds', 'maxDate', 'minDate', 'showClear', 'showClose', 'showTodayButton',
                    'sideBySide', 'stepping', 'tooltips', 'useCurrent', 'useStrict', 'viewDate', 'widgetParent', 'widgetPositioning'], function (key, index) {
                    if (angular.isDefined(attrs[key]))
                        config[key] = scope.$parent.$eval(attrs[key]);
                });

                // initialization
                var picker = (<any>elem).datetimepicker(config).data("DateTimePicker"),
                    pickerVisible = false,
                    toggleElement = angular.isDefined(attrs['datetimePickerToggle']) ?
                        angular.element(attrs['datetimePickerToggle']) : elem.closest('.input-group').find('.datetime-picker-toggle'),
                    onChangeHandler = (<any>(<any>scope)).onChange ? (<any>scope).onChange() : null,
                    onErrorHandler = (<any>(<any>scope)).onError ? (<any>scope).onError() : null,
                    onHideHandler = (<any>scope).onHide ? (<any>scope).onHide() : null,
                    onShowHandler = (<any>scope).onShow ? (<any>scope).onShow() : null,
                    onUpdateHandler = (<any>scope).onUpdate ? (<any>scope).onUpdate() : null;

                // format model value into view value
                ngModelCtrl.$formatters.push(function (modelValue) {
                    if (ngModelCtrl.$isEmpty(modelValue))
                        return '';
                    var date = moment(modelValue);
                    if (!date.isValid())
                        return '';
                    return date.format(picker.format());
                });

                // parse view value into model value
                ngModelCtrl.$parsers.push(function (viewValue) {
                    if (ngModelCtrl.$isEmpty(viewValue))
                        return null;
                    var date = moment(viewValue, picker.format());
                    if (!date.isValid())
                        return null;
                    return date.format('YYYY-MM-DDTHH:mm');
                });

                // rendering
                ngModelCtrl.$render = function () {
                    var date = picker.options().defaultDate || null;
                    if (ngModelCtrl.$viewValue) {
                        date = ngModelCtrl.$viewValue;
                    }
                    picker.date(date);
                };

                // initial render
                ngModelCtrl.$render();

                // outside click
                var clickOutsideFn = function (e) {
                    if (!e || !e.target || e.target == elem[0] || angular.element(e).hasClass('bootstrap-datetimepicker-widget'))
                        return;
                    picker.hide();
                };

                // toggle
                var toggleFn = function () {
                    if (!pickerVisible) {
                        picker.show();
                    } else {
                        picker.hide();
                    }
                };

                // cleanup events when scope destroyed
                scope.$on('$destroy', function () {
                    $document.off('click', clickOutsideFn);
                    angular.element($window).off('blur', clickOutsideFn);
                    toggleElement.off('click', toggleFn);
                });

                // events
                elem.on({
                    'dp.change': function (e) {
                        var formatters = ngModelCtrl.$formatters,
                            idx = formatters.length,
                            formattedValue = (<any>e).date || '';
                        while (idx--) {
                            formattedValue = formatters[idx](formattedValue);
                        }
                        if (ngModelCtrl.$viewValue === formattedValue)
                            return;

                        ngModelCtrl.$setViewValue(formattedValue);

                        if (onChangeHandler) {
                            onChangeHandler(e);
                        }
                    },
                    'dp.error': function (e) {
                        // force reverted view value to update model value
                        ngModelCtrl.$setViewValue(elem.val());

                        if (onErrorHandler) {
                            onErrorHandler(e);
                        }
                    },
                    'dp.hide': function (e) {
                        if (onHideHandler) {
                            onHideHandler(e);
                        }
                        pickerVisible = false;

                        $document.off('click', clickOutsideFn);
                        angular.element($window).off('blur', clickOutsideFn);
                    },
                    'dp.show': function (e) {
                        if (onShowHandler) {
                            onShowHandler();
                        }
                        pickerVisible = true;

                        $timeout(function () {
                            $document.on('click', clickOutsideFn);
                            angular.element($window).on('blur', clickOutsideFn);
                        }, 0);
                    },
                    'dp.update': function (e) {
                        if (onUpdateHandler) {
                            onUpdateHandler(e);
                        }
                    }
                });

                toggleElement.on('click', toggleFn);

                if (angular.isDefined(attrs.min)) {
                    var minVal;
                    ngModelCtrl.$validators.min = function (value) {
                        return !isValidDatetime(value) || angular.isUndefined(minVal) || !moment(value).isBefore(minVal);
                    };
                    attrs.$observe('min', function (val) {
                        minVal = parseObservedDatetimeValue(val);
                        ngModelCtrl.$validate();
                    });
                }

                if (angular.isDefined(attrs.max)) {
                    var maxVal;
                    ngModelCtrl.$validators.max = function (value) {
                        return !isValidDatetime(value) || angular.isUndefined(maxVal) || !moment(value).isAfter(maxVal);
                    };
                    attrs.$observe('max', function (val) {
                        maxVal = parseObservedDatetimeValue(val);
                        ngModelCtrl.$validate();
                    });
                }

                function isValidDatetime(value) {
                    return !ngModelCtrl.$isEmpty(value) && moment(value).isValid();
                }

                function parseObservedDatetimeValue(value) {
                    var datetime = moment(value);
                    return !ngModelCtrl.$isEmpty(value) && datetime.isValid() ? datetime : undefined;
                }
            }
        };
    }]);
